
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/search",
      function () {
        return require("private-next-pages/education/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/search"])
      });
    }
  